angular
.module('resources.Album', ['ngResource'])
.factory('Album', ['$resource', function ($resource) {
  var Resource = $resource('/api/admin/albums/:id', {id: '@_id'}, {
    query: {
      method: 'GET',
      isArray: false
    },
    update: {
      method: 'PUT'
    },
    create: {
      url: '/api/admin/albums',
      method: 'POST'
    },
    // search: {
    //   method: 'GET',
    //   url: '/api/admin/users-search',
    //   isArray: true
    // },
    getAll: {
      method: 'GET',
      url: '/api/admin/albums',
      isArray: false
    }
  });

  return Resource;
}]);



// WEBPACK FOOTER //
// ./client/src/common/resources/Album.js